import cx from 'classnames'

import Styles from './LeftSideBar.module.scss'

interface Props {
  children?: JSX.Element | JSX.Element[] | null | undefined
  showPanel: Boolean
  closePanel: Function
}

export const LeftSideBar = ({ children, showPanel }: Props) => {
  if (!showPanel) return null
  return (
    <div className={cx(Styles.sidebar, { [Styles.locked]: true })}>
      <div className={Styles.sidebarInner}>
        <div className={Styles.sidebarContent}>{children}</div>
      </div>
    </div>
  )
}
